import './style/App.sass';
import FlipClock from './FlipClock.js';

import React, { Component } from 'react';

class App extends Component {
  render() {
    return (
      <div className="cnm">
        <h1 className="header">Days since contacting Matt</h1>
        <FlipClock countDate={[2021, 1, 12]} />
      </div>
    );
  }
}

export default App;
